// extracted by mini-css-extract-plugin
export default {"root":"task_from_matches_card___root___c94c852a","selectWrap":"task_from_matches_card___selectWrap___a35fec4e","buttonWrap":"task_from_matches_card___buttonWrap___aa701a9e"};